import Checkbox from './Checkbox';

export type CheckboxGroupOpts<T> = {
  options: {
    id: T;
    checkbox: Checkbox;
  }[];
  onSelect: (id: T) => void;
};

export class CheckboxGroup<T = string> {
  constructor({ options, onSelect }: CheckboxGroupOpts<T>) {
    options.forEach(({ id, checkbox }, i) => {
      checkbox.onChange = () => {
        // There can be only one
        if (checkbox.isChecked) {
          options.forEach((opt, j) => {
            if (i !== j) {
              opt.checkbox.updateState(false);
            }
          });
          onSelect(id);
        } else {
          checkbox.updateState(true, true);
        }
      };
    });
  }
}
